export default __webpack_public_path__ + "static/media/Asr.369b6719.mp3";